import { BakoRequestAPI } from '../../lib/wallets/fuel/connectors/bako-safe/Bako';
import { BakoSafeConnector } from '../../lib/wallets/fuel/connectors/bako-safe';
import { FuelProvider, NetworkConfig } from '@fuels/react';
import { FueletWalletConnector } from '../../lib/wallets/fuel/connectors/fuelet-wallet';
import { FuelWalletConnector } from '../../lib/wallets/fuel/connectors/fuel-wallet';
import { useSettingsState } from '@/context/settings';
import { useMemo } from 'react';

const HOST_URL = 'https://api.bako.global';

const FuelProviderWrapper = ({
    children
}: { children: React.ReactNode }) => {

    const { networks } = useSettingsState()

    const fuelConfig = {
        connectors: [
            new FuelWalletConnector(),
            new BakoSafeConnector({
                api: new BakoRequestAPI(HOST_URL)
            }),
            new FueletWalletConnector(),
        ]
    }

    const fuelNetworks: Array<NetworkConfig> = useMemo(() => networks.filter(n => n.caip2Id.startsWith('fuel:')).map((network) => ({
        chainId: Number(network.chainId!)
    })), [networks])

    return (
        <FuelProvider uiConfig={{ suggestBridge: false }} theme={'dark'} fuelConfig={fuelConfig} networks={fuelNetworks}>
            {children}
        </FuelProvider>
    );
};


export default FuelProviderWrapper;